import http, { Http } from '@/lib/http';
import { GetScheduleResponse } from '../types';

type Params = {
  projectId: string;
  orderId: string;
}

function getScheduleCtor(http: Http) {
  return async ({ projectId, orderId }: Params): Promise<GetScheduleResponse> => {
    const { data } = await http.get(`/projects/${projectId}/schedules/${orderId}`);

    return data;
  };
}

export const getSchedule = getScheduleCtor(http);
